import { motion } from "framer-motion";
import styled, { css } from "styled-components";
import { SideResponse } from "../../codegen-api";
import { LAYER_COLORS } from "../../constants/design/colors";
import { FONT_SIZE } from "../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";
import { sideColors } from "../../utils/sideColors";
import { SelectButton } from "../shared/Select/style";

export const ContentWrapper = styled.div<{ isMobile?: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border: none;
  background-color: ${LAYER_COLORS.one};
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ${({ isMobile }) =>
    isMobile
      ? css`
          position: relative;
          width: 100%;
          height: 480px;
          overflow-y: auto;
          border-radius: 8px;
        `
      : css`
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          overflow-y: auto;
        `}
`;

export const FormContent = styled.div`
  position: relative;
`;

export const Padding = styled.div`
  padding: 0 ${SPACING.three}px;
`;

export const TradeForm = styled.form`
  position: relative;
`;

export const Form = styled.form`
  position: relative;
  overflow: hidden;
  padding: ${SPACING.three}px ${SPACING.three}px 0;
`;

export const DetailsWrapper = styled.div`
  position: relative;
  padding: 0px ${SPACING.three}px 0;
`;

export const TradeExecutedBar = styled(motion.div)<{ type: SideResponse }>`
  position: absolute;
  height: 2px;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ type }) => sideColors(type).one};
  box-shadow: 4px 8px 40px 4px ${({ type }) => sideColors(type).five};
`;

export const TransactionTypeWrapper = styled.div`
  margin-top: ${SPACING.three}px;

  ${SelectButton} {
    width: 50%;
    padding: ${SPACING.two}px;
    font-size: ${FONT_SIZE.three};
  }
`;

export const OrderTypeWrapper = styled.div`
  margin-top: ${SPACING.three}px;

  ${SelectButton} {
    width: 50%;
    border-radius: ${BORDER_RADIUS.five}px;
  }
`;

export const MarginTypeWrapper = styled.div`
  margin-top: ${SPACING.three}px;
`;
